import React, {useEffect} from 'react'

import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation} from 'react-router-dom'
import {MenuComponent} from '../assets/ts/components'
import {AIChatWidget} from '../../app/components/AiChatN8N/AIChatWidget'
import secureLocalStorage from 'react-secure-storage'

const MasterLayout: React.FC = ({children}) => {
  const location = useLocation()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])
  let idUser = secureLocalStorage.getItem('id_user')
  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <Content>{children}</Content>
      </div>
      <div id='loader' className='hide'>
        {/* <div id='loader-title'></div> */}
        <div id='loader-text'></div>
      </div>
      {/* <AIChatWidget
        webhookUrl='https://process.urbit.com.br/webhook/64a91c20-40c9-4323-8234-e9a8e7dc84b1'
        title='AI Assistant'
        initialMessage='Hello! How can I help you today?'
        primaryColor='#3D47B6'
        sessionId={String(idUser)}
      /> */}
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
